// extracted by mini-css-extract-plugin
export var alertIcon = "_pp-0";